export default __webpack_public_path__ + "static/media/favorite-off-nav.ac80fda4.svg";